import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Box } from '@mui/material';
import ruLocale from 'date-fns/locale/ru';
import * as React from 'react';


interface IDateInputComponent
{
	/** Признак необходимости заполнения */
	IsRequired: boolean,

	/** Признак отключения */
	IsDisabled: boolean,

	/** Признак валидности */
	IsValid: boolean,

	/** Значение */
	Value: Date | null,

	/** Название поля */
	Label: string,

	/** Текст ошибки */
	Error: string,

	/**
	 *  Функция, выполняемая при изменении значения инпута
	 *  @value value - измененное значение инпута
	 */
	OnChange: (value: Date | null) => void,

	/**
	 *  Функция, выполняемая при валидации значения (если элемент не задизаблен)
	 *  @value value - значение инпута
	 */
	OnValidate?: () => boolean
}

export const DateInputComponent: React.FC<IDateInputComponent> =
	(
		// входные параметры компонента
		{ IsRequired, IsDisabled, IsValid, Value, Label, Error, OnChange, OnValidate }: IDateInputComponent
	) =>
	{
		// заворачиваем входные функции в CallBack
		const OnChangeCallback = React.useCallback((value: Date | null) =>
		{
			OnChange(value);
			if (!IsDisabled && OnValidate) OnValidate();
		}, [OnChange, OnValidate, IsDisabled])

		return (
			<div className="input-text-block">
				<label className={(IsValid ? "" : "invalid") + (IsDisabled ? " filled" : "")}>
					<span className="label-title">{Label}&nbsp;{IsRequired && <span className="text-danger">*</span>}</span>
					<span className="form-text-block">
						<LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
							<DesktopDatePicker
								label="Custom input"
								value={Value}
								disabled={IsDisabled}
								onChange={(date: Date | null, keyboardInputValue?: string) => OnChangeCallback(date)}
								renderInput={({ inputRef, inputProps, InputProps }) =>
								{
									inputProps!.placeholder = "дд.мм.гггг";
									return (
										<Box sx={{ display: 'flex', alignItems: 'center' }}>
											<input ref={inputRef} {...inputProps} className="form-text" />
											{InputProps?.endAdornment}
										</Box>
									)
								}}
							/>
						</LocalizationProvider>
					</span>
					<span className="mb-0 error-message text-danger">{Error}</span>
				</label>
			</div>
		)
	}
